import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { addDays, addYears } from "../../../../../../../react-core/utils/date"
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser"
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { BusinessDaysAction } from "../../../../Common/BusinessDays/Actions/BusinessDaysAction";

export const isTaxRelifAvailable = async (dateOfBirth, collectionDate) => {
    if(!dateOfBirth || !collectionDate) {return true;}
    let result = true;
    let adjustedDateOfBirth = JsonDateParser.toDate(dateOfBirth);
    adjustedDateOfBirth = adjustForLeapYearBirthdays(adjustedDateOfBirth);
    const _75Birthiday = addYears(adjustedDateOfBirth, 75);
    const getBusinessDays = (baseDate, future, numberOfDays) => {
        return new Promise((resolve) => {
            BusinessDaysAction.GetBusinessDays(baseDate, future, numberOfDays, false, resolve);
        });
    };
    const availDate = await getBusinessDays(_75Birthiday, false, 11);
    if (dateOfBirth) {
        result = JsonDateParser.toDate(new Date()) < JsonDateParser.toDate(availDate)
        if (result == false)
        {
            return result;
        }
    }
    if (collectionDate) {
        result = JsonDateParser.toDate(collectionDate) < JsonDateParser.toDate(_75Birthiday);
    }

    return result;
};

function adjustForLeapYearBirthdays(date) {
    const yearAt75 = date.getFullYear() + 75;
    //judge if the person born at Feb 29th
    if (date.getMonth() === 1 && date.getDate() === 29) {
        if (!((yearAt75 % 4 === 0 && yearAt75 % 100 !== 0) || (yearAt75 % 400 === 0))) {
            return new Date(date.getFullYear(), 2, 1); //set the date to March 1st
        }
    }
    return new Date(date.getTime());
}

export const getMoneyFormat = (val: number): string => {
    let formatMoney = MoneyDisplayHelper.FromatMoneyDisplay(Math.abs(val), CurrencyCode.GBP);
    if (val < 0) {
        formatMoney = "-" + formatMoney;
    }
    if (val == 0){
        formatMoney = "-";
    }
    return formatMoney;
};
